import { MenuGrid } from '@/components/MenuGrid';

export function HomePage() {
  return <MenuGrid />;
}
